import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

import { useSurvey } from 'hooks/units/index';
import { useSelector } from 'react-redux';
import { getColor, getColorText } from 'store/settings';

const ButtonAnswer = ({ isLoading, onSubmit, isOneQuestion, index }) => {
  const survey = useSurvey();
  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  return (
    <div className="flexRow justify-space-between mt-2">
      {isOneQuestion && (
        <button
          className="btn-bg-color"
          disabled={isLoading}
          onClick={onSubmit}
          style={{
            backgroundColor: `${colorStatus}`,
            color: `${colorTextStatus}`,
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'white';
            e.target.style.borderColor = colorStatus;
            e.target.style.color = colorStatus;
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = colorStatus;
            e.target.style.color = colorTextStatus;
          }}
        >
          {survey?.current === survey?.total
            ? 'Submit Survey'
            : 'Submit answer'}
        </button>
      )}
      <h3>
        Question {isOneQuestion ? survey?.current : index + 1} of{' '}
        {survey?.total}
      </h3>
    </div>
  );
};

ButtonAnswer.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ButtonAnswer;
